import { createContext } from "react";

/* A sticky CardHeader needs its Card to stop clipping: while the Card is
   overflow-hidden, the Card itself is the header's scroll box, so the header
   never sticks. The Card provides this register; a sticky header calls it on
   mount and calls the returned function on unmount. The Card shows overflow
   only while at least one sticky header is registered, so every other Card
   keeps today's classes. Outside a Card there is nothing to register with. */
export const CardStickyContext = createContext<(() => () => void) | null>(null);
